import { render, staticRenderFns } from "./ClientStatisticsComponent.vue?vue&type=template&id=fded9e10&"
import script from "./ClientStatisticsComponent.vue?vue&type=script&lang=ts&"
export * from "./ClientStatisticsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports